import { useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  /** Buttons or menus shown to the right of the title (below it on narrow screens). */
  actions?: ReactNode;
  /** Small content above the title, e.g. a back link or breadcrumbs. */
  eyebrow?: ReactNode;
}

/** The title block of a page, in orno's page-title and page-lead. Also sets the document title. */
export function PageHeader({ title, description, actions, eyebrow }: PageHeaderProps) {
  const { t } = useTranslation();
  const appName = t('appName');

  useEffect(() => {
    document.title = `${title} · ${appName}`;
  }, [title, appName]);

  return (
    <header className="page-header">
      <div className="page-header__text">
        {eyebrow ? <div className="note">{eyebrow}</div> : null}
        <h1 className="page-title">{title}</h1>
        {description ? <p className="page-lead">{description}</p> : null}
      </div>
      {actions ? <div className="cluster">{actions}</div> : null}
    </header>
  );
}
